export default "__VITE_ASSET__BLnwu1RG__"